import PropTypes from 'prop-types'
import React from 'react'

export const Header = ({children}) =>
  <div className='korisnicki-profil-small-heading'>
    <p>{children}</p>
  </div>

Header.propTypes = {
  children: PropTypes.string.isRequired
}
